/*
  Phone carousels for the native homepage sections (pt-home-*).
  Markup: <div class="pth-track" data-pth-carousel>slides…</div>
          <div class="pth-dots" data-pth-dots></div>
  The track is a CSS scroll-snap row under 768px; this only adds the dots
  and keeps them in sync. On wider screens the track is a normal row and
  the dots stay hidden by CSS.
*/
(() => {
  const init = (track) => {
    if (track.dataset.pthReady) return;
    track.dataset.pthReady = 'true';
    const dots = track.parentElement.querySelector('[data-pth-dots]');
    const slides = Array.from(track.children);
    if (!dots || slides.length < 2) return;

    const buttons = slides.map((slide, i) => {
      const b = document.createElement('button');
      b.type = 'button';
      b.setAttribute('aria-label', `Show item ${i + 1} of ${slides.length}`);
      b.addEventListener('click', () => {
        track.scrollTo({ left: slide.offsetLeft - track.offsetLeft, behavior: 'smooth' });
      });
      dots.appendChild(b);
      return b;
    });

    const update = () => {
      const center = track.scrollLeft + track.clientWidth / 2;
      let active = 0;
      slides.forEach((slide, i) => {
        const mid = slide.offsetLeft - track.offsetLeft + slide.offsetWidth / 2;
        const best = slides[active].offsetLeft - track.offsetLeft + slides[active].offsetWidth / 2;
        if (Math.abs(mid - center) < Math.abs(best - center)) active = i;
      });
      buttons.forEach((b, i) => b.setAttribute('aria-current', i === active ? 'true' : 'false'));
    };

    let frame = 0;
    track.addEventListener('scroll', () => {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(update);
    }, { passive: true });
    update();
  };

  const boot = () => document.querySelectorAll('[data-pth-carousel]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
